import { onScopeDispose, ref, type Ref } from 'vue';

/** Mirrors the CSS breakpoints in tokens.css. */
export const BREAKPOINTS = { tablet: 640, desktop: 1024 } as const;

export interface Breakpoint {
  isPhone: Ref<boolean>;
  isDesktop: Ref<boolean>;
}

/** Reactive viewport class, for behavior that CSS alone can't express. */
export function useBreakpoint(win: Pick<Window, 'matchMedia'> = window): Breakpoint {
  const phone = win.matchMedia(`(max-width: ${BREAKPOINTS.tablet - 0.02}px)`);
  const desktop = win.matchMedia(`(min-width: ${BREAKPOINTS.desktop}px)`);
  const isPhone = ref(phone.matches);
  const isDesktop = ref(desktop.matches);
  const onPhone = (e: MediaQueryListEvent) => (isPhone.value = e.matches);
  const onDesktop = (e: MediaQueryListEvent) => (isDesktop.value = e.matches);
  phone.addEventListener('change', onPhone);
  desktop.addEventListener('change', onDesktop);
  onScopeDispose(() => {
    phone.removeEventListener('change', onPhone);
    desktop.removeEventListener('change', onDesktop);
  });
  return { isPhone, isDesktop };
}
